 <div class="notifylist-wrapper"> 
    <div class="table-container">
      <div class="table-top-wrapper mb-3">
        <div>
            <h2 class="text-heading-3 text-start mb-1 text-capitalize" (click)="goBack()"><img class="previewback" src="../../../../assets/images/storelist/backarrow.svg">Notifications</h2>
        </div> 
      </div>
      <div class="table-wrapper">
        <table class="table table-responsive">
          <thead class="position-relative"> 
            <tr>
              <th class="" scope="col">Store
                <span (click)="openStoreListPopup($event)">
                  <img *ngIf="selectedStatusForStore.length === 0" class="sort-img" src="../../../assets/images/dropdown.png" alt="">
                  <img *ngIf="selectedStatusForStore.length !== 0" class="ms-1" src="../../../assets/images/check.svg" alt="" srcset="">
                </span>
                <div class="popup table-header-storepopup" id="store_for-popup">
                  <form>
                      <div class="form-group">
                        <input name="uploaded_for" id="Main WH" type="checkbox" value="Main WH" [checked]="selectedStatusForStore.includes('Main WH') ? true : false" (change)="onSelectStore($event)">
                        <label for="Main WH">Main WH</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Mater Private Cork" type="checkbox" value="Mater Private Cork" [checked]="selectedStatusForStore.includes('Mater Private Cork') ? true : false" (change)="onSelectStore($event)">
                        <label for="Mater Private Cork">Mater Private Cork</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Hampshire Hospitals NHSFT" type="checkbox" value="Hampshire Hospitals NHSFT" [checked]="selectedStatusForStore.includes('Hampshire Hospitals NHSFT') ? true : false" (change)="onSelectStore($event)">
                        <label for="Hampshire Hospitals NHSFT">Hampshire Hospitals NHSFT</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Royal Hampshire County Hospital" type="checkbox" value="Royal Hampshire County Hospital" [checked]="selectedStatusForStore.includes('Royal Hampshire County Hospital') ? true : false" (change)="onSelectStore($event)">
                        <label for="Royal Hampshire County Hospital">Royal Hampshire County Hospital</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Torbay Hospital" type="checkbox" value="Torbay Hospital" [checked]="selectedStatusForStore.includes('Torbay Hospital') ? true : false" (change)="onSelectStore($event)">
                        <label for="Torbay Hospital">Torbay Hospital</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Mater cork" type="checkbox" value="Mater cork" [checked]="selectedStatusForStore.includes('Mater cork') ? true : false" (change)="onSelectStore($event)">
                        <label for="Mater cork">Mater cork</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="Mater Private" type="checkbox" value="Mater Private" [checked]="selectedStatusForStore.includes('Mater Private') ? true : false" (change)="onSelectStore($event)">
                        <label for="Mater Private">Mater Private</label>
                      </div>
                  </form> 
                </div>
              </th>
              <th class="" scope="col">Notification</th>
              <th class="" scope="col">Date & Time
                <span (click)="raisedAtSort()">
                  <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                </span>
              </th>
              <th class="" scope="col">Status  
                <span (click)="openStatusListPopup($event)">
                  <img *ngIf="selectedStatusForAlert.length === 0" class="sort-img" src="../../../assets/images/dropdown.png" alt="">
                  <img *ngIf="selectedStatusForAlert.length !== 0" class="ms-1" src="../../../assets/images/check.svg" alt="" srcset="">
                </span>
                <div class="popup table-header-popup" id="status_for-popup">
                  <form>
                      <div class="form-group">
                        <input name="uploaded_for" id="consumed" type="checkbox" value="consumed" [checked]="selectedStatusForAlert.includes('consumed') ? true : false" (change)="onSelectStatus($event)">
                        <label for="consumed">consumed</label>
                      </div>
                      <div class="form-group">
                        <input name="uploaded_for" id="fulfilled" type="checkbox" value="fulfilled" [checked]="selectedStatusForAlert.includes('fulfilled') ? true : false" (change)="onSelectStatus($event)">
                        <label for="fulfilled">fulfilled</label>
                      </div>
                  </form> 
                </div>
              </th>
            </tr> 
          </thead>
          <tbody> 
            <tr *ngFor="let notifylist of notifylist">
                <td class="text-start">{{ notifylist.store_name }}</td>
                <td class="text-start">
                    {{ notifylist.product_name ? notifylist.product_name : (notifylist.shipment_id ? '' + notifylist.shipment_id : '') }}
                  </td>
                <td class="text-start">{{ timestampFormat(notifylist.updated_at, "DD/MM/YYYY, HH:mm:ss") }}</td>
                <td class="text-start"><span class="" [class.statusconsume]="notifylist.status === 'consumed'" [class.statusfulfilled]="notifylist.status === 'fulfilled'">
                    {{ notifylist.status }}
                  </span></td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div> 
    <div class="" *ngIf="paginationData.totalPage > 1">
        <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
    </div>
</div> 